import { render, staticRenderFns } from "./single.vue?vue&type=template&id=0603f550&scoped=true&"
import script from "./single.vue?vue&type=script&lang=ts&"
export * from "./single.vue?vue&type=script&lang=ts&"
import style0 from "./single.vue?vue&type=style&index=0&id=0603f550&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0603f550",
  null
  
)

export default component.exports